var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.121,
    height: 10.121,
    viewBox: "0 0 10.121 10.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(-5.091 -5.091)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    x1: 8,
    y2: 8,
    transform: "translate(6.151 6.151)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    x2: 8,
    y2: 8,
    transform: "translate(6.151 6.151)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBlueIcon);
export default __webpack_public_path__ + "static/media/cancel-blue-icon.48e505577d8b6683e133259bc54c14ba.svg";
export { ForwardRef as ReactComponent };